import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css'
import Popup from 'reactjs-popup';
import settings from '../../settings';

const closeIcon = `${settings.IMAGES_BASE_URL}/images/assets/close_btn_black.svg`;
const prevIcon = `${settings.IMAGES_BASE_URL}/images/assets/prev.svg`;
const nextIcon = `${settings.IMAGES_BASE_URL}/images/assets/next.svg`;

class PossibilitiesItem extends React.Component {
  state = {
    width: '',
    show: false,
    isExpanded: false
  }

  onExpanded = () => [ this.setState({ isExpanded: !this.state.isExpanded }) ];

  componentDidMount() {
    this.setState({
      width: window.innerWidth
    });
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  handleCardDisplay = () => {
    const currentState = this.state.show;
    this.setState({ show: !currentState });
  };

  render() {
    const { width } = this.state;
    const isMobile = width < 1200;
    const isDesktop = width >= 1200;

    return (
      <React.Fragment>
        {isMobile && (
          <div className="possibilityaccordion__item">
            <div className={`possibilityaccordion__card ${this.state.isExpanded ? 'is-expanded' : ' '} `}>
              <button className="possibilityaccordion__card__header" onClick={this.onExpanded}>
                <h3>{this.props.text}</h3>
              </button>
              <div className="possibilityaccordion__card__content">
                <LazyLoadImage effect="blur" src={this.props.image} alt={this.props.Name + ' sml'} />
                <h5>{this.props.title}</h5>
                <p>{this.props.description}</p>
              </div>
            </div>
          </div>
        )}
        {isDesktop && (
          <Popup
            trigger={
              <div className="possibilities__content__item">
                <h3>{this.props.text}</h3>
              </div>
            }
            onOpen={() => {
              this.props.onModalOpen(this.props.index);
            }}
            onClose={this.props.onModalClose}
            modal
          >
            {(close) => (
              <div className="possibilitymodal">
                <div className="possibilitymodal__content row">
                  <LazyLoadImage effect="blur"
                    src={this.props.modalImage}
                    alt={this.props.imageAlt}
                    onClick={this.props.onNext}
                    onKeyDown={this.props.onNext}
                    role="presentation"
                  />
                  <button className="close" onClick={close} onKeyDown={close}>
                    <LazyLoadImage effect="blur" src={closeIcon} alt="close" className="close-icon" />
                  </button>
                  <button className="prev" onClick={this.props.onPrev}>
                    <LazyLoadImage effect="blur" src={prevIcon} alt="close" className="prev-icon" />
                  </button>
                  <button className="next" onClick={this.props.onNext}>
                    <LazyLoadImage effect="blur" src={nextIcon} alt="close" className="next-icon" />
                  </button>
                  <div className="possibilitymodal__text">
                    <h4>{this.props.modalTitle}</h4>
                    <p>{this.props.modalDescription}</p>
                  </div>
                </div>
              </div>
            )}
          </Popup>
        )}
      </React.Fragment>
    );
  }
}

export default PossibilitiesItem;
